import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/MinusSquare.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(s, { ref: a, ...r, weights: t }));
o.displayName = "MinusSquareIcon";
const m = o;
export {
  m as MinusSquare,
  o as MinusSquareIcon
};
